import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { UserAPIConstant } from '@/api/constant/user'
import { Page } from '@/api/model/base'
import { AuthInfo, PasswordRequest, VersionInfoRequest, VersionInfoRecord } from '@/api/model/user'

export class UserService extends BaseService {
    protected userConstant: UserAPIConstant
    constructor() {
        super()
        this.userConstant = new UserAPIConstant()
    }

    login(): Observable<AuthInfo> {
        return this.request(this.userConstant.login())
    }

    logout(): Observable<void> {
        return this.request(this.userConstant.logout())
    }

    updatePassword(data: PasswordRequest): Observable<void> {
        return this.request(this.userConstant.updatePassword(data))
    }

    queryVersionInfo(data: VersionInfoRequest): Observable<Page<VersionInfoRecord>> {
        return this.request(this.userConstant.queryVersionInfo(data))
    }
}
